export const state = {
  stage: null,
  stages: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/stage/state.js